"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgEyeFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M2 12c0-.93.654-1.452.654-1.452C5.855 7.516 8.99 6.005 11.995 6c3.006-.005 6.17 1.516 9.37 4.548 0 0 .63.522.63 1.452 0 .93-.608 1.43-.608 1.43-3.21 3.047-6.387 4.565-9.392 4.57-3.004.005-6.142-1.517-9.344-4.551 0 0-.651-.519-.651-1.449zm9.995 4c2.214 0 4-1.786 4-4s-1.786-4-4-4c-2.213 0-4 1.786-4 4s1.787 4 4 4zm2-4a2.001 2.001 0 11-4.002-.001 2.001 2.001 0 014.002.001z' }))); };
exports.default = SvgEyeFilled;
//# sourceMappingURL=EyeFilled.js.map